import { CartHeaders } from "../../../Cart/index";
import { ICartData } from "../../../Cart/types/ICartData";
import { AlertModal } from "../../../Components";
import { CustomPopover } from "../../../Components/CustomPopover";
import { DataLayerModelFactory } from "../../../Services/DataLayer/index";
import { AjaxPost, IAjaxPostConfig } from "../../../Services/index";
import { IProductRowItem, ProductToAdd } from "../Models/index";
import { IPromoResponseModel } from "../../../Cart/types/IPromoResponseModel";

CustomPopover();
var turnAllocationDialogOn: boolean = false;
var GetAdvisoryAllocation = `This product is on order allocation based on your historical 12-month purchases. 
                The quantity listed as Alloc is the Qty each remaining for you to order this month.  
                Each month this quantity will be available to order, and your order will be given top priority 
                IF stock becomes available. If you would like to be placed on our Backorder Priority List to be notified 
                when additional product is available, please contact Customer Care with the additional quantity you require.`


var GetAdvisoryNoOrderAllocation = `
                Inventory on certain items may be temporarily unavailable due to a surge in demand or a disruption to
                the supply chain. If you would like to be placed on our Backorder Priority List (BOPL) to be notified 
                when product is available, please contact Customer Care with the quantity and size(s) you require.`

var GetAdvisoryNoOrderAllocationHeading = "We’re sorry!  We are not taking orders for this item."
var GetAdvisoryAllocationHeading = "Product Allocation Limit";
var GetAllocationsNoticeAddressBook = [
    {
        ContactRecNo: 0,
        Email: "CustomerCare@life-assist.com",
        FirstName: "Customer",
        LastName: "Care",
        Name: "Customer Care",
        Phone: "800-824-6016"
    }
];

var failedItemList = [];
var failedItemNotTakingOrder = [];

export default class AddToCartVM {
    public RestrictionItems: KnockoutObservableArray<any> = ko.observableArray([]);
    public ApprovalType: KnockoutObservable<any> = ko.observable(null);
    public SelectedApprover: KnockoutObservable<any> = ko.observable(null);
    public SelectApprover = (data, context) => {

        let self = context;

        let endpoint = ""

        if (self.ApprovalType() === "R" || self.ApprovalType() === "Q" || self.ApprovalType() === "A" || self.ApprovalType() === "N") {
            endpoint = self.ApprovalType() === "R" ? "/ShoppingCart/SendRestrictEmail" : "/ShoppingCart/SendQuotaRequestEmail";

            switch (self.ApprovalType()) {
                case "A":
                case "N":
                    endpoint = "/ShoppingCart/SendAllocationEmail"
                    break;
                case "Q":
                    endpoint = "/ShoppingCart/SendQuotaRequestEmail"
                    break;
                case "R":
                    endpoint = "/ShoppingCart/SendRestrictEmail"
                    break;
                default:

                    break;
            }

        }


        let comment = self.ApprovalType() === "R" ? self.RestrictionComment : self.Comment;


        function HiglightSelectedAltItem(data) {
            localStorage.setItem('LastSearchTerm', data.ItemID)
            window.open(data.ProductUrl);
        }

        function SendRequestToApprover(payload) {
            if (endpoint != "") {
                let ajaxPost: IAjaxPostConfig = {
                    endpoint: endpoint,
                    payload: JSON.stringify(ko.toJS(payload))
                }

                new AjaxPost(ajaxPost);
            }
            $('#email-approver').collapse('hide');
            $("#modal-add-item-restriction").modal('hide');
        }

        if (!data)
            return;

        console.debug("SelectApprover data: ", { data, context });

        self.SelectedApprover(data);


        if (self.ApprovalType() === "A" || self.ApprovalType() === "N") {

            $("#modal-add-item-restriction").on('click', '#send-email-button',
                function (event) {

                    var itemsAddedForAllocationMsg = [];
                    var itemsAddedForAllocationNotTakingMsg = [];

                    if (context.ItemsToAdd) {
                        context.ItemsToAdd().forEach(function (item) {
                            if (item.QtySelected() > item.QtySelected.originalValue) {
                                item.added = item.QtySelected() - item.QtySelected.originalValue;
                                itemsAddedForAllocationMsg.push(item.ItemID);
                            }
                        })
                    }

                    failedItemList.forEach(function (item) {
                        itemsAddedForAllocationMsg.push(item.ItemID);
                    })

                    failedItemNotTakingOrder.forEach(function (item) {
                        itemsAddedForAllocationNotTakingMsg.push(item.ItemID);
                    })


                    let AllocationRequest: any = {
                        EmailTo: data.Email,
                        Comment: comment,
                        ProductURL: window.location.href,
                        ItemsListOver: itemsAddedForAllocationMsg,
                        ItemsListNotTaking: itemsAddedForAllocationNotTakingMsg
                    };
                    failedItemList = [];
                    failedItemNotTakingOrder = [];
                    itemsAddedForAllocationMsg = [];
                    itemsAddedForAllocationNotTakingMsg = [];

                    event.stopImmediatePropagation();

                    let validationGroup = ko.validation.group({
                        CustEmail: self.CustEmail,
                        CustName: self.CustName,
                        CustPhone: self.CustPhone
                    });

                    let isValid = () => validationGroup().length > 0 ? false : true;

                    // Set values to isModified to trigger validation
                    self.CustEmail.isModified(true);
                    self.CustName.isModified(true);

                    if (!window.UserMeta) {
                        if (isValid()) {
                            // Add extra fields to payload if not logged in
                            AllocationRequest.CustName = ko.toJSON(self.CustName);
                            AllocationRequest.CustPhone = ko.toJSON(self.CustPhone);
                            AllocationRequest.CustEmail = ko.toJSON(self.CustEmail);

                            SendRequestToApprover(AllocationRequest);
                        }
                    } else { // Ignore validation if logged in, extra fields don't matter
                        SendRequestToApprover(AllocationRequest);
                    }


                });
        }
        else {
            let request: any = {
                EmailTo: data.Email,
                Comment: comment,
                ProductURL: window.location.href
            };

            $("#modal-add-item-restriction").on('click', '#send-email-button',
                function (event) {
                    event.stopImmediatePropagation();
                    SendRequestToApprover(request);

                });
        }

        let request: any = {
            EmailTo: data.Email,
            Comment: comment,
            ProductURL: window.location.href
        };

        $("#modal-add-item-restriction").on('click', '#send-email-button',
            function (event) {
                event.stopImmediatePropagation();
                SendRequestToApprover(request);
            });
    }
    public ContractPricingLevels: KnockoutObservableArray<any> = ko.observableArray([]);
    public AddressBook: KnockoutObservableArray<any> = ko.observableArray([]);
    public RestrictionComment: KnockoutObservable<string> = ko.observable(null);
    public CustEmail: KnockoutObservable<string> = ko.observable()
        .extend({ required: true, email: true, maxLength: 250 });
    public CustName: KnockoutObservable<string> = ko.observable()
        .extend({ required: true, maxLength: 250 });
    public CustPhone: KnockoutObservable<string> = ko.observable()
        .extend({ phoneUS: true, maxLength: 30 });
    public AddToContract: KnockoutObservable<string>;
    public OnSale: KnockoutObservable<string>;
    public OnContract: KnockoutObservable<boolean>;
    public ShowRetrictionModal = (data: IProductRowItem, restriction: string, context) => {
        let title = $('#modal-add-item-restriction').find('.modal-title').first(),
            message = $('#restriction-message');

        let heading = "Restriction in Effect";
        let self = context;

        self.ApprovalType("R");
        self.Comment(null);

        console.debug("ShowRetrictionModal data: ", { data, restriction, context });

        return new Promise<void>((resolve, reject) => {

            switch (restriction) {
                case "Allocation Limit Reached.":
                    self.ApprovalType("A");
                    heading = GetAdvisoryAllocationHeading;
                    break;
                case "Allocation Not Taking Orders.":
                    self.ApprovalType("N");
                    heading = GetAdvisoryNoOrderAllocationHeading;
                    break;
                case "Quota Exceeded":
                    self.ApprovalType("Q")
                    heading = "Quota Exceeded";
                    break;
                case "OnlyContractPrice":
                    heading = "Contract Pricing Restriction in Effect";
                    break;
                case "OnlySupplyList":
                    heading = "Supply List Restriction in Effect";
                    break;
                default:
                    return resolve();
                    break;
            }

            title.text(heading);

            if (restriction === "Allocation Limit Reached." || restriction === "Allocation Not Taking Orders.") {

                self.AddressBook(GetAllocationsNoticeAddressBook)

                title.text()
                let msgText = self.ApprovalType() === "A" ? GetAdvisoryAllocation : GetAdvisoryNoOrderAllocation
                //inject altshtml here
                let clickHereText = "</br>See available alternatives</br>";
                let AltItemsString = AddToCartVM.AltItemsHtml(clickHereText, data);
                msgText += AltItemsString;



                message.html(msgText)
                $('#modal-add-item-restriction').modal('show');
                return resolve();
            }
            else {
                let url = "/ShoppingCart/GetRestrictAdmins/";
                let endpoint = restriction !== "Quota Exceeded" ? url + restriction : url + "QuotaExceeded";

                $.getJSON(endpoint, function (res) {
                    if (!res)
                        return;

                    let advisory = res.Message.toString().trim() || "Item restriction in effect";
                    let approvers: Array<any> = res.RestrictAdmins || [];

                    console.debug("Restriction approvers: ", approvers);

                    // Clear the address book before filling it up again.
                    self.AddressBook([]);

                    approvers.forEach((item) => {
                        self.AddressBook.push(item);
                    })

                    message.text(advisory);

                    $('#modal-add-item-restriction').modal('show');
                    resolve();

                })
            }

        })
    }

    static AddToContractFunction = (ItemID: string, arrayToUpdate: KnockoutObservableArray<any>, context: any) => {
        let self = context;
        let itemIndex = arrayToUpdate().findIndex((x => x.ItemID === ItemID));

        console.debug("AddToContractFunction data: ", { ItemID, arrayToUpdate, context });

        return new Promise<void>(function (resolve, reject) {
            return new AjaxPost({
                endpoint: '/ShoppingCart/AddItemToContract',
                payload: JSON.stringify({ ItemID: ItemID }),
                cbFunction: function (res) {

                    $.each(arrayToUpdate()[itemIndex].UoMPrices(), (i, o) => {
                        $.each(self.ContractPricingLevels(), (j, o1) => {
                            if (o.UMQty === o1.UMQty) {
                                o.Price = o1.SpecialPrice;
                                o.Display("$" + o1.SpecialPrice.toFixed(2) + " " + o1.UoM);
                            }
                        })
                    });

                    arrayToUpdate()[itemIndex].OnContract(true);
                    arrayToUpdate.valueHasMutated();

                    resolve();
                },
                errFunction: function (err) {
                    reject(err);
                }

            })
        })

    }

    static getSelectedSupplyList = () => {
        var cookieArr = document.cookie.split(";");
        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");

            if ("currentSupplyListID" == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return "";
    }

    static AltItemsHtml = (clickHereText: string, data: any) => {
        let AltItemsString = "";
        let BackOrderString = clickHereText = "" ? "View Alternatives" : clickHereText;
        if (data.AltItemList?.length > 0) {
            //case 'IN STOCK', "Expiring", "Backorder", "Allocation"                                
            AltItemsString += "<div><span>"
            AltItemsString += "<div class='px-lg-1 a text-primary'  role='button' onclick='document.getElementById(\"altPanel_" + data.ItemID + "\").style.display= ( document.getElementById(\"altPanel_" + data.ItemID + "\").style.display == \"none\" ? \"block\": \"none\" )'><strong><span class='text-danger'><i class='text-danger fas fa-exclamation-triangle'></i>&nbsp;" + BackOrderString + "</span></strong></div>";
            AltItemsString += "</span></div>"
            AltItemsString += "<div id='altPanel_" + data.ItemID + "' style='display:none; margin-bottom:5px; border: 1px solid rgba(0, 0, 0, 0.2); border-radius:.3rem; font-size: .875rem; max-width:400px; '   >";
            data.AltItemList.forEach(function (altItem) {
                AltItemsString +=
                    "<div role='presentation' class='tt-dataset tt-dataset-Products'>" +
                    "<div class='d-flex flex-row my-auto p-0 m-0 px-1 border-bottom tt-suggestion tt-selectable'>" +
                    "<div class='col-2 p-0 m-0 pr-2 my-1'>" + "<img class='img' src='/Content/ProductImages/80x60/" + altItem.ImageName + "'/>" + "</div>" +
                    "<div class='d-flex flex-column col-10 p-0 m-0'>" +
                    "<div class='text-truncate' >" + altItem.ItemAltText + "</div>" +
                    "<div>" +
                    "<a class='px-lg-1 text-primary' style='text-decoration: underline !important;' href='javascript:void(0)'   onclick='localStorage.setItem(" + "\"" + "LastSearchTerm" + "\"" + "," + "\"" + altItem.ItemID + "\"" + ");   window.open(" + "\"" + altItem.ProductUrl + "\"" + ")'>" + altItem.ItemID + "</a>" +
                    "</div>" +
                    "</div>" +
                    "</div>" +
                    "</div>";
            });
            AltItemsString += "</div>";
            return AltItemsString;
        }
    }
    static LA_Alert = (alertContent: string, context) => {
        let self = context;
        self.AlertModal.DataTarget = ko.observable(null);
        self.AlertModal.Title("Life-Assist Alert");
        alertContent = "<center><h2 style='color:green'>" + alertContent + "</h2></center>";
        self.AlertModal.Content(alertContent);
        $("#alertModal").modal('show');
        $("#alertModal").find("#main-button").hide();
        $("#alertModal").find("#secondary-button").hide();
        $("#alertModal").find(".modal-dialog").removeClass("modal-lg");
        if (turnAllocationDialogOn) $("#alertModal").modal("hide");
    }
    static AddToCart = (product: any, context) => {
        if (!product) return;
        let qtyOrdered = product.QtyOrdered || product.Quantity();
        if (qtyOrdered === 0 && !product.UoMPrices().filter(uom => uom.UMQty === product.UMQtySelected())[0]?.IsInCart()) return;
        let self = context;
        self.ContractPricingLevels([]);
        let init = true;

        function modalConfirmAdd(data) {
            let dismissPermanent = () => {
                if (window.localStorage.getItem("SuppressAddConfirm")) {
                    return true;
                }
            }
            if (dismissPermanent()) {
                return;
            }

            console.log("SPECIAL PRICE: ", SpecialPrice);

            let clickHereText = "This item is on an extended backorder.</br> <span style='text-decoration: underline;'>Click here</span> to view possible alternatives";
            let AltItemsString = AddToCartVM.AltItemsHtml(clickHereText, data);

            self.AlertModal.DataTarget = ko.observable(null);
            let info = "Add to your Cart | " + data.ItemID;
            let qtyOrdered = data.QuantityOrdered;
            let qtyAdded = (qtyOrdered == 1 || qtyOrdered === undefined) ? ("1 unit of ") : (qtyOrdered + " units of ");
            let alertContent = qtyAdded + "<b>" + data.Description + "</b>";
            if (SpecialPrice)
                alertContent += " was added to your cart. ";
            else
                alertContent += (onSale == "Y") ? (addToContract == "N" ? " was added to your cart at <b>Current Sale Price</b>. " : " was added to your cart.")
                    : (addToContract == "Y" ? " was added to your cart. "
                        : " was added to your cart. ");
            if (qtyOrdered === 0) {
                info = "Shopping Cart Item Removal Information.";
                alertContent = data.ItemID + " has been removed from your shopping cart.";
                if ($(".qtyContainer" + data.ItemID).attr("old-value") == "0")
                    return
            }

            //if we are going to show alt items format the alt items to the right
            if (data.AltItemList.length > 0) {
                let flexBoxContent = "<div class='container' style = 'display: flex;' >" +
                    "<div style='width: 40%;' >" +
                    alertContent +
                    "</div>" +
                    "<div style='flex-grow: 1' >" +
                    AltItemsString
                "</div>" +
                    "</div>"
                alertContent = flexBoxContent
                //alertContent += AltItemsString
            }
            AskReviewCart(alertContent, info);
        }

        function AskReviewCart(alertContent, info) {
            self.AlertModal.Title(info);
            alertContent += "<br><b style='color:Blue'>Would you like to review your shopping cart?</b>";
            self.AlertModal.Content(alertContent);
            $("#alertModal").modal('show');
            self.AlertModal.MainButtonText("Review Cart");
            $('#main-button').on('click', function () {
                $("#alertModal").modal('hide');
                return window.location.href = "/ShoppingCart";
            })
            self.AlertModal.SecondButtonText("Never Ask Again");
            $("#secondary-button").click(() => {
                window.localStorage.setItem("SuppressAddConfirm", "true");
                $("#alertModal").modal('hide');
            })
            $("#alertModal").find("#main-button").show();
            $("#alertModal").find("#secondary-button").show();
            $("#alertModal").find(".modal-dialog").addClass("modal-lg");
            if (turnAllocationDialogOn) $("#alertModal").modal("hide");
        }

        function addToCart(data) {
            let itemToAdd = ProductToAdd(data);
            var selectedSupplyListID = AddToCartVM.getSelectedSupplyList()
            return new Promise((resolve, reject) => {
                return new AjaxPost({
                    backdrop: true,
                    endpoint: '/ShoppingCart/EditCart',
                    payload: JSON.stringify({
                        item: ko.toJS(itemToAdd),
                        action: "add",
                        supplyListID: selectedSupplyListID,
                    }),
                    cbFunction: (response) => {
                        resolve({
                            response: response,
                            itemToAdd: itemToAdd,
                            data: data
                        });
                    },
                    errFunction: (err) => {
                        reject(err);
                    }
                });
            });
        }

        let onSale = "N";
        let addToContract = "N";
        let SpecialPrice = false;
        function processResult(result) {
            if (!result)
                return;
            let response = result.response;
            let itemToAdd = result.itemToAdd;
            let data = result.data;

            // Refresh models
            let cart: ICartData = response;
            let cartVM = (<any>window).cartVM;
            let header: CartHeaders = (<any>cartVM).header

            // Set the cart key
            localStorage.setItem("CartSessionKey", cart.CartOrderNo.toString());
            header.LocalKey(cart.CartOrderNo.toString());

            console.debug("Cart to be passed in as new header", cart);
            header.ParseCartData(cart).then(() => {
                header.UpdateRequestID();
            });
            console.log("DATA", data);
            // Flags to work with
            let msgHeader: string = response.Messages.split(':')[0].toString().trim(),
                msgBody: string = response.Messages.split(':')[1].toString().trim(),
                msgSuccess: boolean = msgHeader === 'Success',
                msgError: boolean = msgHeader === 'Error',
                //isContract: boolean = msgBody != "AddToContract" ? true : false;
                isContract: boolean = msgBody.indexOf("AddToContract") >= 0 ? false : true;
            onSale = data.OnSale;
            addToContract = data.AddToContract;
            if (onSale === undefined || addToContract == undefined) {
                // get the OnSale/AddtoContract
                $.ajax({
                    url: '/ShoppingCart/GetSaleContractItemInfo/' + data.ItemID,
                    async: false,
                    success: function (res) {
                        onSale = res.split(":")[0];
                        addToContract = res.split(":")[1];
                    }
                })
            }
            //console.log("DATA:", data);
            SpecialPrice = msgBody.indexOf("SPECIALPRICE") >= 0 ? true : false;
            console.log(onSale + ":" + addToContract + ":" + isContract + ":" + SpecialPrice + '\n' + response.Messages);
            if (response.Messages.indexOf(" has been removed") >= 0) {
                AskReviewCart(data.ItemID + " has been removed from your shopping cart.", "Shopping Cart Item Removal Information.");
                return;
            }
            return new Promise((resolve) => {
                if (msgError) {
                    localStorage.setItem("CartSessionKey", response.CartOrderNo.toString());
                    header.LocalKey(response.CartOrderNo.toString());
                    if (msgBody !== "QuoteProvided") {
                        self.ShowRetrictionModal(product, msgBody, context);
                        //for single add item push to the failedItemList, we will sort it out in the backend what email to send
                        failedItemList = [];
                        failedItemNotTakingOrder = [];
                        failedItemList.push(product)
                    }
                    else {
                        self.AlertModal.Title("Cart Locked");

                        let alertContent = "<strong>We're sorry, but this cart is locked to modifications.</strong>";
                        alertContent += "<p>Please start a new cart or contact ";
                        alertContent += "<a class='text-primary' href='mailto:quotes@life-assist.com'>quotes@life-assist.com</a> "
                        alertContent += "or Customer Care at <a class='text-primary' href='tel:800-824-6016'>800-824-6016</a> "
                        alertContent += "to request additions or modifications to this cart.</p>";
                        alertContent += "<p class='my-1'>We'd be happy to assist you!</p>";
                        alertContent += "<p>Please reference Cart #" + itemToAdd.CartOrderID.toString().trim() + "</p>";
                        self.AlertModal.Content(alertContent);
                        $("#alertModal").modal('show');
                    }
                }
                else if (msgSuccess) {
                    localStorage.setItem("CartSessionKey", response.CartOrderNo.toString());
                    header.LocalKey(response.CartOrderNo.toString());
                    resolve(response);
                    console.log("From Product Page: automatic just 1");
                    let qtyOrdered = (data.QuantityOrdered == undefined) ? 1 :
                        (data.QuantityOrdered > 0) ? data.QuantityOrdered : data.Quantity();
                    console.log("qtyOrdered:" + qtyOrdered);
                    let prompt = (qtyOrdered == 1) ? ("1 unit of ") : (qtyOrdered + " units of ");
                    prompt += "<b>" + data.Description + "</b>";
                    if (!isContract) {
                        $.getJSON('/ShoppingCart/GetContractItemInfo/' + data.ItemID)
                            .done((result) => {
                                if (!result)
                                    return;
                                let err = result.toString().split(':')[0] === "Error" ? true : false;
                                if (!err && SpecialPrice == true) {
                                    self.ContractPricingLevels(result);
                                }
                            })
                            .then(function () {
                                // find  the item's OnSale and AddToContract
                                let title = "Add to your Cart | " + data.ItemID; // + "====> " + (isContract === true ? "Y" : "N") + ":" + onSale + ":" + addToContract;
                                if (addToContract == "Y") {
                                    self.ContractItems = [];
                                    if (onSale == "N") self.ContractItems.push({ ItemID: data.ItemID });
                                }
                                let modal = $("#modal-add-to-contract")
                                if (onSale == "N" && addToContract == "N") {
                                    prompt += " has successfully been added to your cart <u>but cannot be added to your Contract Pricing Online</u>."
                                    prompt += "<div style='color:red'>Please contact our Customer Care team or your Life Assist Account Manager for pricing assistance.</div>";
                                    AskReviewCart(prompt, title);
                                    return;
                                }
                                /*
                                    else
                                        if (onSale == "Y" && addToContract == "Y") {
                                            modal.find(".modal-title").html(prompt + " has successfully been added to your cart at <b> sale price </b>.<br><b style='color:red'>Sale items cannot be added to contract. </b>");
                                            modal.find(".modal-body").show();
                                            modal.find("#AllowContract").hide()
                                            modal.find(".footer1").hide();
                                            modal.find(".footer2").hide();
                                        }
                                */
                                else
                                    if (onSale == "Y" && (addToContract == "N" || addToContract == "Y")) {
                                        AskReviewCart(prompt + " has successfully been added to your cart at <b>Current Sale Price</b>.", title);
                                        return;
                                    }
                                    else {  //  N and Y
                                        if (SpecialPrice == false) {
                                            AskReviewCart(prompt + " has successfully been added to your cart.", title);
                                            return;
                                        }
                                        else {
                                            modal.find(".modal-title").html(prompt + " has successfully been added to your cart.");
                                            modal.find("#AllowContract").show()
                                            modal.find(".footer1").show();
                                            modal.find(".footer2").hide();
                                        }

                                    }
                                $('#modal-add-to-contract').modal('show');
                            })
                    }

                }

            }).then((headers: ICartData) => {
                if (msgSuccess && isContract) {
                    modalConfirmAdd(product);
                }
                header.ParseCartData(headers);
                console.debug("Items in cart after update", headers.CartItems);
                header.UpdateRequestID();
            });
        };

        if (init) {
            addToCart(product).then(processResult);
            init = false;
        }

    };

    static AddChoicesToCart = (viewModel) => {
        let self = viewModel;
        let items = [];
        let ContractItemsAll = [];
        if (self.ItemsToAdd)
            $.each(self.ItemsToAdd(), function (index, item) {
                if (item.QtySelected() === item.QtySelected.originalValue) {
                    return;
                }
                item.QtyOrdered = item.QtySelected();
                console.log("HERE IS THE ITEM: " + item);
                items.push(item);
            })
        if (items.length < 1) {
            self.AlertModal.Title("Life-Assist Notification")
            self.AlertModal.Content("You don't have any item to update.\nPlease select items from our <a href='/products/'><u>products</u></a>.");
            $('#alertModal').modal('show');
            return;
        }

        let itemsAdded = [];
        items.forEach(function (item) {
            if (item.QtySelected() > item.QtySelected.originalValue) {
                item.added = item.QtySelected() - item.QtySelected.originalValue;
                itemsAdded.push(item);
            }
        })

        let itemsRemoved = [];
        items.forEach(function (item) {
            if (item.QtySelected() < item.QtySelected.originalValue) {
                item.removed = item.QtySelected.originalValue - item.QtySelected();
                itemsRemoved.push(item);
            }
        })

        //console.log("AddChoicesToCart items: ", items);

        let dataLayerItem = (obj) => {

            let item = Object.assign({}, obj);
            let allProducts = [];

            if (typeof (self.ItemRows) === 'function') {
                allProducts = self.ItemRows();
            }
            else {
                allProducts = self.ItemRowModel().concat(self.AccessoryRowModel());
            }

            if (!obj.UoMPrices) {
                obj = allProducts.find(function (item) {
                    return item.ItemID === obj.ItemID;
                });
            };

            let UoMSelected = obj.UoMPrices().find(function (item) {
                return item.UMQty === obj.UMQtySelected();
            });

            let index = allProducts.findIndex((item) => {
                return item.ItemID === obj.ItemID;
            })

            return {
                brand: obj.Name || obj.VendName,
                category: obj.Heading || obj.Description,
                id: obj.ItemID,
                name: obj.SDname || obj.Description,
                price: UoMSelected.Price,
                variant: UoMSelected.UoM,
                quantity: item.added || item.removed || obj.Quantity(),
                position: index
            }
        }

        let addDataLayerArray = itemsAdded.map(dataLayerItem);
        let removeDataLayerArray = itemsRemoved.map(dataLayerItem);
        console.debug("dataLayer items array: ", { addDataLayerArray, removeDataLayerArray });
        let SpecialPriceShown = true;
        function addManyToCart(itemsArray) {
            let cartVM = (<any>window).cartVM;
            let header = (<any>cartVM).header;
            console.info("Adding multiple items to cart...")

            function itemToAdd(item) {
                return {
                    ItemID: item.ItemID,
                    UoMPrices: [{
                        ItemID: item.ItemID,
                        UoM: item.UoM,
                        UoMPackSize: item.UMQty,
                        UMQty: item.UMQty,
                        Price: item.Price,
                        QtyOrdered: item.QtySelected(),
                        QtyDiff: !!item.added ? item.added : !!item.removed ? -item.removed : 0
                    }],
                    QtyOrdered: item.QtySelected(),
                    SDname: item.Description
                };
            }

            var selectedSupplyListID = AddToCartVM.getSelectedSupplyList()
            let payload = itemsArray.map(itemToAdd);
            var data = { items: payload, supplyListID: selectedSupplyListID };
            return new Promise(function (resolve, reject) {
                return new AjaxPost({
                    backdrop: true,
                    endpoint: '/ShoppingCart/UpdateCart',
                    payload: JSON.stringify(data),
                    cbFunction: function (response) {
                        if (addDataLayerArray.length > 0)
                            window.dataLayer.push(new DataLayerModelFactory().addToCart(addDataLayerArray));
                        if (removeDataLayerArray.length > 0)
                            window.dataLayer.push(new DataLayerModelFactory().removeFromCart(removeDataLayerArray));
                        resolve(response);
                    },
                    errFunction: function (err) {
                        reject(err);
                    }
                });
            });
        } ////=== UpdateCart

        function processResults(results) {
            self.ContractItems = [];

            return new Promise(function (resolve, reject) {

                if (!results) {
                    reject("No results to process.");
                }
                let success = 0,
                    fail = 0,
                    successItems = [],
                    failItems = [];

                results.ItemList.forEach(function (result, index) {
                    if (result.Message.split(':')[1].trim() === "AddToContract" || result.Message.split(':')[1].trim() === "AddToContractSPECIALPRICE") {
                        ContractItemsAll.push(result);
                    }
                    if (result.Message.split(':')[0].trim() !== "Error") {
                        success += 1;
                        successItems.push(result);
                    } else {
                        fail += 1;
                        failItems.push(result);
                    }

                });

                self.ContractItems = ContractItemsAll.reduce(function (a, b) {
                    function indexOfProperty(a, b) {
                        for (var i = 0; i < a.length; i++) {
                            if (a[i].ItemID == b.ItemID) {
                                return i;
                            }
                        }
                        return -1;
                    }

                    if (indexOfProperty(a, b) < 0) a.push(b);
                    return a;
                }, []);


                let message = success + (success > 1 ? " items " : " item ") + "added to / updated in cart. ";
                if (fail > 0) {
                    message += fail + (fail > 1 ? " items " : " item ") + "were not added to / updated in cart. ";
                };

                let returnObj = { message: message, failItems: failItems, successItems: successItems };

                resolve(returnObj);
            })

        }

        function getContractPrices() {
            console.info("Getting contract pricing for items...")
            return new Promise(function (resolve, reject) {
                let contractPromises = [];

                $.each(self.ContractItems, function (index, item) {
                    contractPromises.push(getSpecialPrice(item.ItemID));
                })

                if (contractPromises.length < 1) {
                    console.info("No special pricing available")
                    reject("No special pricing available.");
                    SpecialPriceShown = false;

                    return;
                }

                Promise.all(contractPromises)
                    .then(function (results) {
                        SpecialPriceShown = true;
                        resolve(results);
                    });
            })
        }

        function displaySpecialPrice(results) {
            if (results) {
                $('#page-preloader').hide();
                self.ContractPricingLevels([]);
                var ContractPricingLength = 0;
                results.forEach(function (result, index) {
                    // Display only the UoMs that were added
                    ContractItemsAll.forEach(function (item, index) {
                        result.forEach(function (row, i) {
                            if (row.ItemID === item.ItemID && row.UMQty === item.UoMPackSize) {
                                $.ajax({
                                    url: '/ShoppingCart/GetSaleContractItemInfo/' + item.ItemID,
                                    async: false,
                                    success: function (res) {
                                        if (res === "N:Y") {   ///=== or should it be  || res === "Y:Y" ) AMR
                                            self.ContractPricingLevels.push(row);
                                            ContractPricingLength++;
                                        }
                                    }
                                })
                            }
                        })
                    })
                });
                var modal = $('#modal-add-choices-to-contract');
                if (ContractPricingLength === 0) {
                    modal.modal('hide');
                    SpecialPriceShown = false;
                }
                else {
                    if (ContractPricingLength === 1) {
                        modal.find("#numItems").html("this item");
                    }
                    else {
                        modal.find("#numItems").html("these items");
                    }
                    modal.find(".modal-body").show();
                    modal.find("#noItemToContract").hide();
                    modal.find(".modal-footer").show();
                    modal.modal('show');
                    $("#alertModal").modal('hide');
                    SpecialPriceShown = true;

                }

            }
        }

        let OnlySupplyList = [],
            OnlyContractPrice = [],
            QuotaExceeded = [],
            QuoteProvided = false,
            AllocationExceeded = [],
            AllocationExceededNoOrder = [],
            SuccessItemsResponse = [];

        function sortRestrictions(results) {
            // Reset arrays
            OnlySupplyList = [];
            OnlyContractPrice = [];
            QuotaExceeded = [];
            AllocationExceeded = [];
            AllocationExceededNoOrder = [],
                SuccessItemsResponse = results.ItemList;

            if (results.Cart.LastActivity === "Requested Quote") {
                QuoteProvided = true;
            } else {
                results.ItemList.forEach(function (item, indx) {
                    for (const uom of item.UoMPrices) {
                        if (uom.MessageCode === "OnlySupplyList") {
                            item.Message = "Not on any supply list";
                            OnlySupplyList.push(item); break;
                        }
                        else if (uom.MessageCode === "OnlyContractPrice") {
                            item.Message = "Not on contract pricing list";
                            OnlyContractPrice.push(item); break;
                        }
                        else if (uom.MessageCode === "SuppyListOverQuota") {
                            item.Message = "Quota for item has exceeded";
                            QuotaExceeded.push(item); break;
                        }
                        else if (uom.MessageCode === "OnAllocation") {
                            item.Message = "Allocation Limit Reached.";
                            AllocationExceeded.push(item); break;
                        }
                        else if (uom.MessageCode === "OnBackorder") {
                            item.Message = "Allocation Not Taking Orders.";
                            AllocationExceededNoOrder.push(item); break;
                        }
                    }
                })
            }
        }

        function getRestrictAdmins() {
            return new Promise(function (resolve, reject) {
                return $.getJSON('/ShoppingCart/GetRestrictAdmins/OnlySupplyList', function (response) {
                    resolve(response);
                })
            })
        }

        function getSpecialPrice(ItemID) {
            return new Promise(function (resolve, reject) {
                $.getJSON('/ShoppingCart/GetContractItemInfo/' + ItemID, function (result) {
                    if (!result)
                        return reject("No results.");
                    if (result.toString().split(':')[0] !== "Error") {
                        return resolve(result);
                    }
                });
            })
        }



        addManyToCart(items)
            // Select contract items from result
            .then(function (results) {
                // Refresh models
                let cart: ICartData = (<any>results).Cart;
                let cartVM = (<any>window).cartVM;
                let header: CartHeaders = (<any>cartVM).header
                // Set the cart key                
                localStorage.setItem("CartSessionKey", (<any>results).Cart.CartOrderNo.toString());
                header.LocalKey((<any>results).Cart.CartOrderNo.toString());
                console.debug("Cart to be passed in as new header", cart);
                header.ParseCartData(cart).then(() => {
                    header.UpdateRequestID();
                });

                // sort restricted item results into separate lists                
                sortRestrictions(results);
                if (!QuoteProvided) {
                    processResults(results)
                        .then(((resolve: any) => {
                            console.debug("processResults Message", resolve.message);
                            if (resolve.successItems.length > 0) {
                                console.debug("Items added/updated", resolve.successItems);
                            }
                            if (resolve.failItems.length > 0) {
                                console.debug("Items that failed", resolve.failItems);
                            }
                        }))
                        .catch(function (reject) {
                            $('#page-preloader').hide();
                        });
                } else {
                    self.AlertModal.Title("Cart Locked");
                    let alertContent = "<strong>We're sorry, but this cart is locked to modifications.</strong>";
                    alertContent += "<p>Please start a new cart or contact ";
                    alertContent += "<a class='text-primary' href='mailto:quotes@life-assist.com'>quotes@life-assist.com</a> "
                    alertContent += "or Customer Care at <a class='text-primary' href='tel:800-824-6016'>800-824-6016</a> "
                    alertContent += "to request additions or modifications to this cart.</p>";
                    alertContent += "<p class='my-1'>We'd be happy to assist you!</p>";
                    alertContent += "<p>Please reference Cart #" + header.LocalKey() + "</p>";
                    self.AlertModal.Content(alertContent);
                    $("#alertModal").modal('show');
                }

            })

            // do stuff with restricted items list
            .then(function () {
                let cartVM = (<any>window).cartVM;
                let header = (<any>cartVM).header;
                let array = [];
                failedItemList = [];
                failedItemNotTakingOrder = [];

                let isAllocation = false;
                let isAllocation_NoOrderTaken = false;
                if (OnlySupplyList.length > 0) {
                    OnlySupplyList.forEach((item, indx) => {
                        array.push(item);
                    })
                }
                if (QuotaExceeded.length > 0) {
                    QuotaExceeded.forEach((item, indx) => {
                        array.push(item);
                    })
                }
                if (OnlyContractPrice.length > 0) {
                    OnlyContractPrice.forEach((item, indx) => {
                        array.push(item);
                    })
                }
                if (AllocationExceeded.length > 0) {
                    AllocationExceeded.forEach((item, indx) => {
                        array.push(item);
                        isAllocation = true;
                        self.ApprovalType("A");
                        failedItemList.push(item)
                    })
                }
                if (AllocationExceededNoOrder.length > 0) {
                    AllocationExceededNoOrder.forEach((item, indx) => {
                        array.push(item);
                        isAllocation = true;
                        isAllocation_NoOrderTaken = true;
                        self.ApprovalType("N");
                        failedItemNotTakingOrder.push(item)
                    })
                }


                if (array.length > 0) {
                    if (!isAllocation) {
                        getRestrictAdmins().then((results) => {

                            self.AddressBook((<any>results).RestrictAdmins);
                            self.RestrictionItems(array);
                            self.RestrictionItems.valueHasMutated();

                            let message = array.length > 1 ? "Some items you selected are have been restricted and therefore, "
                                + "are not approved items. Please contact your administrator(s) to request the approval for these items." :
                                "The item you selected is restricted and therefore, is not an approved item. "
                                + "Please contact your administrator(s) to request the approval for this item.";
                            let title = array.length > 1 ? "Supply List Restrictions in Effect" : "Supply List Restriction in Effect";
                            $('#modal-add-item-restriction').find('.modal-title').first().text(title);
                            $('#restriction-message').text(message);
                            $('#modal-add-item-restriction').modal('show');
                        }).catch((err) => {
                            $('#page-preloader').hide();
                            console.error("getRestrictAdmins error: ", err);
                        })
                    }
                    else if (isAllocation) {
                        getRestrictAdmins().then((results) => {

                            self.AddressBook(GetAllocationsNoticeAddressBook)
                            self.RestrictionItems(array);
                            self.RestrictionItems.valueHasMutated();

                            let message = isAllocation_NoOrderTaken ? GetAdvisoryNoOrderAllocation : GetAdvisoryAllocation;
                            let title = isAllocation_NoOrderTaken ? GetAdvisoryNoOrderAllocationHeading : GetAdvisoryAllocationHeading;
                            $('#modal-add-item-restriction').find('.modal-title').first().text(title);
                            $('#restriction-message').html(message);
                            $('#modal-add-item-restriction').modal('show');
                        }).catch((err) => {
                            $('#page-preloader').hide();
                            console.error("getRestrictAdmins error: ", err);
                        })
                    }
                }
            })
            // Display results of special prices query
            .then(function () {
                getContractPrices()
                    .then(function (results) {
                        displaySpecialPrice(results)
                    })
                    .catch(function (reject) {
                        $('#page-preloader').hide();
                    });
            })
            .then(function () {
                function AskReviewCart(alertContent, info) {
                    self.AlertModal.Title(info);
                    alertContent += "<br><b style='color:Blue'>Would you like to review your shopping cart?</b>";
                    self.AlertModal.Content(alertContent);
                    $("#alertModal").modal('show');
                    self.AlertModal.MainButtonText("Review Cart");
                    $('#main-button').on('click', function () {
                        $("#alertModal").modal('hide');
                        return window.location.href = "/ShoppingCart";
                    })
                    self.AlertModal.SecondButtonText("Never Ask Again");
                    $("#secondary-button").click(() => {
                        window.localStorage.setItem("SuppressAddConfirm", "true");
                        $("#alertModal").modal('hide');
                    })
                    $("#alertModal").find("#main-button").show();
                    $("#alertModal").find("#secondary-button").show();
                    $("#alertModal").find(".modal-dialog").addClass("modal-lg");
                }

                {

                    let clickHereText = "This item is on an extended backorder.  <span style='text-decoration: underline;'>Click here</span> to view possible alternatives";
                    let cartItems = "";
                    for (let x = 0; x < items.length; x++) {
                        let removed = items[x].removed;
                        let added = items[x].added;
                        console.log("removed:" + removed + " | added:" + added);
                        let whatToDo = (removed === undefined || removed == 0) ? (added === 1 ? "Added " + added + " unit" : "Added " + added + " units")
                            : (removed === 1 ? "Removed " + removed + " unit" : "Removed " + removed + " units")
                        cartItems += "<b>" + items[x].ItemID + "</b> (" + whatToDo + " of " + items[x].Description;
                        let logic = ""
                        if (items[x].OnSale === "Y" && (items[0].AddToContract === "N" || items[0].AddToContract === "Y")) {
                            logic = " at <b>Current Sale Price</b>)";
                        }
                        if (items[x].OnSale === "N" && items[0].AddToContract === "Y") {
                            logic = ")";
                        }
                        cartItems += logic + " " + (items[x].QtySelected() === 0 ? "<b style='color:red'> Nothing left!</b>" : "") + "<br>";
                        $('#quantity-field-' + items[x].ItemID).attr("old-value", items[x].QtySelected());
                        items[x].removed = 0; items[x].added = 0;  /// clear values

                        if (added != undefined && added > 0) {
                            let index = SuccessItemsResponse.findIndex(z => z.ItemID === items[x].ItemID);
                            if (index >= 0) {
                                if (SuccessItemsResponse[index]) {
                                    if (SuccessItemsResponse[index]?.AltItemList?.length > 0) {
                                        let AltItemsString = AddToCartVM.AltItemsHtml(clickHereText, SuccessItemsResponse[index]);
                                        cartItems += AltItemsString
                                    }
                                }
                            }
                        }

                    }
                    if (items.length == 1) {
                        if (cartItems.indexOf("Nothing left") >= 0) {
                            AskReviewCart(items[0].ItemID + " has been removed from your shopping cart.",
                                "Shopping Cart Item Removal Information.");
                            return;
                        }
                        let extraPrice = "."
                        if (items[0].OnSale == "Y" && (items[0].AddToContract === "N" || items[0].AddToContract === "Y")) {
                            extraPrice = " at <b>Current Sale Price</b>."
                        }
                        if (items[0].OnSale == "N" && items[0].AddToContract === "Y") {
                            extraPrice = "."
                        }
                        AskReviewCart(items[0].QtySelected() + ((items[0].QtySelected() === 1) ? " unit of " : " units of ") + "<b>" + items[0].Description
                            + "</b> has successfully been added to your cart" + extraPrice, "Add to your Cart | " + items[0].ItemID);
                    }
                    else {
                        AskReviewCart(cartItems, items.length + " Items updated on your cart.");
                    }
                }
            })




    };

    static EventListeners = ((vm) => {

        let self = vm;

        $('#create-new-supply-list').on('click', () => {

            let SupplyListName = $('#new-list-name').val().toString().trim();


            if (SupplyListName.length === 0) {
                $("#new-list-err").text("List name cannot be empty!");
                return;
            }

            self.CreateNewList(SupplyListName, vm);

            let endpoint = "/ShoppingCart/CreateSupplyList";

            $(document).ajaxSuccess((event, xhr, options) => {
                if (options.url === endpoint) {
                    $("#new-list-err").empty();
                    $('#create-new-list-modal').modal('hide');
                    $('#new-list-name').val("")
                }
            })

            $(document).ajaxError((evt, xhr, opt, exc) => {
                if (opt.url === endpoint) {
                    $('#new-list-name').val("")
                    $("#new-list-err").text(exc);
                }
            })

        });
        $("#alertModal").modal("hide")

        $('#modal-add-item-restriction').on("hidden.bs.modal", function () {
            //$("#alertModal").modal("show");   // the isse is the cart will report wrong items has been added
            //turnAllocationDialogOn = false;  we will revisit this feature if needed --- AMR
        });

        $('#modal-add-item-restriction').on("show.bs.modal", function () {
            turnAllocationDialogOn = true;
            // I will cheat on this one to give time for the other modal to even create -- AMR 
            setTimeout(function () {
                $("#alertModal").modal("hide")
            }, 100);


        });

        $('#create-new-list-back').click(function () {

            $('#create-new-list-modal').modal('hide');
            $('#add-to-list-modal').modal('show');
        });

        $('#add-to-contract-button').click(function () {
            let contractItem = self.ContractItems[0].ItemID;
            self.AddToContractFunction(contractItem, vm.ArrayToUpdate(contractItem), vm);
            $('#modal-add-to-contract').modal('hide');
        });

        $('#add-choices-to-contract-button').click(function () {
            if (self.ContractItems.length < 1) {
                $('#modal-add-choices-to-contract').modal('hide');
                return;
            }

            console.debug("Contract Items to submit", self.ContractItems);

            let promises = [];

            self.ContractItems.forEach((item) => {
                promises.push(self.AddToContractFunction(item.ItemID, self.ArrayToUpdate(item.ItemID), self));
            });

            if (promises.length < 1) {
                $('#modal-add-choices-to-contract').modal('hide');
                return;
            }

            $('#page-preloader').show();
            Promise.all(promises)
                .then(function () {
                    $('#page-preloader').hide();
                    $('#modal-add-choices-to-contract').modal('hide');
                });

        })

    })

}